/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmi_nav_calc_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Health & fitness calculator`)
};

const es_bmi_nav_calc_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de salud y fitness`)
};

const de_bmi_nav_calc_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesundheits- und Fitness-Rechner`)
};

const nl_bmi_nav_calc_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gezondheid- en fitnessrekenmachine`)
};

const fr_bmi_nav_calc_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculatrice santé et fitness`)
};

const it_bmi_nav_calc_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore sanitario e di fitness`)
};

const pt_br2_bmi_nav_calc_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de saúde e fitness`)
};

const pt_bmi_nav_calc_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de saúde e fitness`)
};

const ja_bmi_nav_calc_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`健康とフィットネス計算機`)
};

const zh_bmi_nav_calc_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`健康与健身计算器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmi_nav_calc_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmi_nav_calc_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmi_nav_calc_desc", locale)
	if (locale === "en") return en_bmi_nav_calc_desc(inputs)
	if (locale === "es") return es_bmi_nav_calc_desc(inputs)
	if (locale === "de") return de_bmi_nav_calc_desc(inputs)
	if (locale === "nl") return nl_bmi_nav_calc_desc(inputs)
	if (locale === "fr") return fr_bmi_nav_calc_desc(inputs)
	if (locale === "it") return it_bmi_nav_calc_desc(inputs)
	if (locale === "pt-BR") return pt_br2_bmi_nav_calc_desc(inputs)
	if (locale === "pt") return pt_bmi_nav_calc_desc(inputs)
	if (locale === "ja") return ja_bmi_nav_calc_desc(inputs)
	return zh_bmi_nav_calc_desc(inputs)
};